import axios, { ResponseType } from 'axios';
import {
  CreateCoctailParamsType,
  IHeaders,
  ImagesUploadParamsType,
  LoginParamsType,
} from './interfaces';
import { AUTH_TOKEN } from '../constans';

const PROTOCOL = 'https:'; //window?.location?.protocol === 'https:' ? window.location.protocol : 'http:'
const HOSTNAME = 'socoy.app'; //window?.location?.hostname || 'socoy.app'
export const BASE_DOMAIN = `${PROTOCOL}//${HOSTNAME}`;
export const API_URL = `${BASE_DOMAIN}/api`;

import useCookie from '../../lib/hooks/useCookie';
import { ICoctail, IGameCard } from '../../types';

const fullUrl = (url: string) => `${API_URL}/${url}`;
const defaultMapper = (x: any) => x;

const getHeaders = () => {
  const headers: IHeaders = {
    Accept: 'application/json',
  };
  const { getCookie } = useCookie();
  const token = getCookie(AUTH_TOKEN);

  try {
    headers['Authorization'] = `Bearer ${token}`;
    return headers;
  } catch (e) {
    return headers;
  }
};

const get =
  (url: string, mapper = defaultMapper) =>
  async (
    params?: Record<string, unknown>,
    headers?: IHeaders,
    responseType: ResponseType = 'json',
  ) => {
    return axios
      .get(fullUrl(url), {
        params: { ...params },
        headers: {
          ...getHeaders(),
          ...headers,
        },
        responseType,
      })
      .then(response => {
        return mapper(response.data);
      });
  };

const post = (url: string) => async (data?: unknown, headers?: IHeaders) => {
  return axios
    .post(fullUrl(url), data, {
      headers: { ...getHeaders(), ...headers },
    })
    .then(response => {
      return { status: response.status, ...response.data };
    });
};

const patch = (url: string) => async (data?: unknown, headers?: IHeaders) => {
  return axios
    .patch(fullUrl(url), data, {
      headers: { ...getHeaders(), ...headers },
    })
    .then(response => {
      return { status: response.status, ...response.data };
    });
};

const _delete = (url: string) => async (params?: unknown, headers?: IHeaders, body?: any) => {
  return axios
    .delete(fullUrl(url), {
      headers: { ...getHeaders(), ...headers },
      params,
      data: {
        ...body,
      },
    })
    .then(response => response.data);
};

export function createApi() {
  const api = {
    user: {
      login: (params: LoginParamsType) => post('auth/login')(params),
    },
    coctails: {
      getCoctails: () => get('cocktails')(),
      createCoctails: (params: CreateCoctailParamsType) => post('cocktails')(params),
      getCoctailById: (id: string) => get(`cocktails/${id}`)(),
      uploadMedia: (params: ImagesUploadParamsType) => post('storage/upload')(params),
      deleteCoctail: (id: string) => _delete(`cocktails/${id}`)(),
      editCoctail: (coctail: ICoctail, id: string) => patch(`cocktails/${id}`)(coctail),
      deleteMedia: (name: string, type: string) =>
        _delete(`storage/${name}`)(undefined, undefined, { type }),
      getMedia: (type: string) => get(`storage/${type}/getAll`)(),
    },
    game: {
      createCard: (params: IGameCard) => post(`game/card`)(params),
      list: () => get('game/cards')(),
      delete: (id: string) => _delete(`game/cards/${id}`)(),
      item: (id: string) => get(`game/cards/${id}`)(),
      editCard: (params: IGameCard, id: string) => patch(`game/cards/${id}`)(params),
    },
  };

  return api;
}

export default createApi();
